
// const API_HOST = process.env.REACT_APP_API_HOST || "http://localhost:8006/api";


const API_HOST = process.env.REACT_APP_API_HOST || "https://api.devnion.com/trading-app-dev/api";

class ApiService {

    static readonly KC: string = `${API_HOST}/kc/v1`;
    
    static readonly Auth: string = `${API_HOST}/auth`;

    static readonly Broker: string = `${API_HOST}/broker`;

}
export default ApiService;
